import React from "react";

const TriageViewFormInput = ({ques}) => {
    switch (ques.quesType) {
        case "text":
            return(
                <div style={{marginTop: "10px"}}>
                    {ques.datefield ?
                    <input
                    required
                    id={ques.id}
                    type='date'
                    max={new Date().toISOString().split('T')[0]}
                    disabled={true}
                    style={{width: "100%", height: "50px"}}
                    value={ques.text}
              />
                :
                            <textarea
                            required
                            id={ques.id}
                            type='text'
                            disabled={true}
                            style={{width: "100%", height: "50px"}}
                            value={ques.notApplicable ? "" : ques.text ? ques.text : ""}
                      ></textarea>
                }
                      
                  </div>
            );
            case "bool":
                return(
                    <div style={{marginTop: "10px"}}>
                        <div className="d-flex align-items-center">
                            <div className="d-flex">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">Yes</label>
                            </div>
                            <div className="d-flex mx-5">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">No</label>
                            </div>
                        </div>
                      </div>
                );
                case "bool-alert":
                    return(
                        <div style={{marginTop: "10px"}}>
                            <div className="d-flex align-items-center">
                                <div className="d-flex">
                                
                                    <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
                                    disabled={true}/>
                                    <label className="mx-2">Yes</label>
                                </div>
                                <div className="d-flex mx-5">
                                
                                    <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
                                    disabled={true}/>
                                    <label className="mx-2">No</label>
                                </div>
                            </div>
                          </div>
                    );
            case "bool-text":
                return(
                    <div style={{marginTop: "10px"}}>
                        <div className="d-flex align-items-center">
                            <div className="d-flex">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">Yes</label>
                            </div>
                            <div className="d-flex mx-5">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">No</label>
                            </div>
                        </div>
                        {ques.questionaryOptions[0] === 'true' ?
                        <>
                        <label className="fw-bold mt-3">{ques?.subQuestionaryOptions[0]?.name}</label>
                        <textarea
                        id={ques.id}
                        type='text'
                        disabled={true}
                        style={{width: "100%", height: "50px"}}
                        value={ques?.subQuestionaryOptions[0]?.text ? ques?.subQuestionaryOptions[0]?.text : ''}

                    ></textarea>
                    </>
                  : null
                        }
                        </div>
                );
                case "bool-text-reverse":
                    return(
                        <div style={{marginTop: "10px"}}>
                            <div className="d-flex align-items-center">
                                <div className="d-flex">
                                
                                    <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
                                    disabled={true}/>
                                    <label className="mx-2">Yes</label>
                                </div>
                                <div className="d-flex mx-5">
                                
                                    <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
                                    disabled={true}/>
                                    <label className="mx-2">No</label>
                                </div>
                            </div>
                            {ques.questionaryOptions[0] === 'false' ?
                            <>
                            <label className="fw-bold mt-3">{ques?.subQuestionaryOptions[0]?.name}</label>
                            <textarea
                            id={ques.id}
                            type='text'
                            disabled={true}
                            style={{width: "100%", height: "50px"}}
                            value={ques?.subQuestionaryOptions[0]?.text ? ques?.subQuestionaryOptions[0]?.text : ''}
                        ></textarea>
                        </>
                      : null
                            }
                            </div>
                    );
        case "bool-text-alert":
            return(
<div style={{marginTop: "10px"}}>
    <div className="d-flex align-items-center">
        <div className="d-flex">
        
            <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
            disabled={true}/>
            <label className="mx-2">Yes</label>
        </div>
        <div className="d-flex mx-5">
        
            <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
            disabled={true}/>
            <label className="mx-2">No</label>
        </div>
    </div>
    {ques.questionaryOptions[0] === 'true' ?
    <>
    <label className="fw-bold mt-3">{ques?.subQuestionaryOptions[0]?.name}</label>
    <textarea
    id={ques.id}
    type='text'
    disabled={true}
    style={{width: "100%", height: "50px"}}
    value={ques?.subQuestionaryOptions[0]?.text ? ques?.subQuestionaryOptions[0]?.text : ''}
></textarea>
</>
: null
    }
    </div>
            );
case "text-and-bool-text":
    return(
<div style={{marginTop: "10px"}}>
                        <div>
                            <div>
                        <textarea
                        id={ques.id}
                        type='text'
                        disabled={true}
                        style={{width: "100%", height: "50px"}}
                        value={ques?.text ? ques?.text : ''}
                    ></textarea>
                        </div>
                        <div>
                        <label className="fw-bold mt-3">{ques?.subQuestionaryOptions[0]?.subHeading}</label>
                        <div className="d-flex align-items-center">
                            <div className="d-flex">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'true' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">Yes</label>
                            </div>
                            <div className="d-flex mx-5">
                            
                                <input type="radio" id={ques.id} checked={ques.questionaryOptions[0] === 'false' ? true : false}
                                disabled={true}/>
                                <label className="mx-2">No</label>
                            </div>
                        </div>
                        </div>
                        </div>
                        {ques.questionaryOptions[0] === 'true' ?
                        <>
                        <label className="fw-bold mt-3">{ques?.subQuestionaryOptions[0]?.name}</label>
                        <textarea
                        id={ques.id}
                        type='text'
                        disabled={true}
                        style={{width: "100%", height: "50px"}}
                        value={ques?.subQuestionaryOptions[0]?.text ? ques?.subQuestionaryOptions[0]?.text : ''}
                    ></textarea>
                    </>
                  : null
                        }
                        </div>
    );
        case "multi":
            return(
                <div style={{marginTop: "10px"}}>
                    {ques.questionaryOptions.map((item,i)=>(
                        <div className="d-flex mb-1" onClick={e=>console.log(ques.id,i)}>
                            
                        <input type="checkbox" id={item.id} checked={item.checked}
                        disabled={true}/>
                        <label className="mx-3 text-capitalize">{item.name}</label>
                        
                        </div>
                        
                    ))}
                </div>
            );
            case "root-multi":
            return(
                <div style={{marginTop: "10px"}}>
                    {ques.questionaryOptions.map((item,i)=>(
                        <div className="d-flex mb-1" onClick={e=>console.log(ques.id,i)}>
                            
                        <input type="checkbox" id={item.id} checked={item.checked}
                        disabled={true}/>
                        <label className="mx-3 text-capitalize">{item.name}</label>
                        
                        </div>
                        
                    ))}
                </div>
            );
        case "radio-multi":
            return(
                <div style={{marginTop: "10px"}}>
                    {ques.questionaryOptions.map((item,i)=>(
                        item.value !== undefined ?
                        <div className="d-flex align-items-center">
                        <div style={{width:'260px'}}>
                            <p className="fw-bold">{item?.name}</p>
                        </div>
                        <div className="d-flex">
                        
                            <input type="radio" id={item.id} checked={item.value[0] === 'true' ? true : false}
                            disabled={true}/>
                            <label className="mx-2">Yes</label>
                        </div>
                        <div className="d-flex mx-5">
                        
                            <input type="radio" id={item.id} checked={item.value[0] === 'false' ? true : false}
                            disabled={true}/>
                            <label className="mx-2">No</label>
                        </div>
                    </div>
                    :
                    // for checkbox
                    <div className="d-flex align-items-center">
                        <div>
                            <p className="fw-bold mt-3">{item?.name}</p>
                        </div>
                    
                    <div className="d-flex mx-3">  
                        <input type="checkbox" id={item.id} checked={item.checked}
                        disabled={true}/>
                        </div>
                    </div>
                    ))}
                </div>
            );
        default:
            return(
                <div>
                    Invalid question
                </div>
            )

    }
}

export default TriageViewFormInput
